import { render, staticRenderFns } from "./account-actions.vue?vue&type=template&id=fc63e6a8&scoped=true&"
import script from "./account-actions.vue?vue&type=script&lang=js&"
export * from "./account-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc63e6a8",
  null
  
)

export default component.exports